module.exports = {
  name: 'masthead-primary',
  settings: {
    set: [
      { width: '1600', height: '900', breakpoint: 'xs' },
      { width: '2400', height: '1350', breakpoint: 'xl' }
    ],
    ratio: null,
    fit: 'crop',
    align: 'center',
  },
}
